/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetHolidaysForDateRangeParams,
  HolidayDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetHolidaysForDateRangeUrl = (params?: GetHolidaysForDateRangeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Holiday/GetHolidaysForDateRange?${stringifiedParams}` : `/api/Holiday/GetHolidaysForDateRange`
}

export const getHolidaysForDateRange = async (params?: GetHolidaysForDateRangeParams, options?: Parameters<typeof customInstance>[1]): Promise<HolidayDto[]> => {

  return customInstance<HolidayDto[]>(getGetHolidaysForDateRangeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHolidaysForDateRangeQueryKey = (params?: GetHolidaysForDateRangeParams,) => {
    return [
    `/api/Holiday/GetHolidaysForDateRange`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHolidaysForDateRangeQueryOptions = <TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHolidaysForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHolidaysForDateRange>>> = ({ signal }) => getHolidaysForDateRange(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHolidaysForDateRangeQueryResult = NonNullable<Awaited<ReturnType<typeof getHolidaysForDateRange>>>
export type GetHolidaysForDateRangeQueryError = ErrorType<unknown>


export function useGetHolidaysForDateRange<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetHolidaysForDateRangeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHolidaysForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getHolidaysForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHolidaysForDateRange<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHolidaysForDateRange>>,
          TError,
          Awaited<ReturnType<typeof getHolidaysForDateRange>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHolidaysForDateRange<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHolidaysForDateRange<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHolidaysForDateRangeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetHolidaysForDateRangeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHolidaysForDateRangeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHolidaysForDateRange>>> = ({ signal }) => getHolidaysForDateRange(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetHolidaysForDateRangeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getHolidaysForDateRange>>>
export type GetHolidaysForDateRangeSuspenseQueryError = ErrorType<unknown>


export function useGetHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params: undefined |  GetHolidaysForDateRangeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHolidaysForDateRangeSuspense<TData = Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError = ErrorType<unknown>>(
 params?: GetHolidaysForDateRangeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHolidaysForDateRange>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHolidaysForDateRangeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






